import { css } from '@compiled/react';

export type CustomRadioProps = {
	checked: boolean;
	name: string;
	value: string;
	onChange: () => void;
};

/**
 * Custom radio button that replaces Atlaskit Radio with a design-approved version.
 * Renders a 24px circular button with a filled inner circle when checked.
 * This component is decorative only (aria-hidden) - the parent ChoiceCard handles accessibility.
 */
export const CustomRadio = ({ checked, name, value, onChange }: CustomRadioProps) => {
	return (
		<label css={labelStyles} aria-hidden="true">
			<input
				type="radio"
				name={name}
				value={value}
				checked={checked}
				onChange={onChange}
				tabIndex={-1}
				css={hiddenInputStyles}
			/>
			<span css={radioVisualStyles}>
				{checked ? (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5Z"
							fill="#1868DB"
						/>
					</svg>
				) : (
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<circle cx="12" cy="12" r="11.5" fill="none" stroke="#8C8F97" strokeWidth="1" />
					</svg>
				)}
			</span>
		</label>
	);
};

const labelStyles = css({
	display: 'inline-flex',
	alignItems: 'center',
	cursor: 'pointer',
	position: 'relative',
});

const hiddenInputStyles = css({
	position: 'absolute',
	opacity: 0,
	width: 0,
	height: 0,
	margin: 0,
	padding: 0,
});

const radioVisualStyles = css({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: 24,
	height: 24,
	flexShrink: 0,
});
